export default function refresh (context, args, flags) {
  window.location.reload()
  return ''
}



// WEBPACK FOOTER //
// ./src/natos/commands/refresh.js